export default __webpack_public_path__ + "static/media/Leggings of the Ichorous.2888522d.jpg";